<div style="margin: 20px; margin-top: 10px !important;">
  <div class="text-center mb-3" style="font-size: 18px">
    {{'trusted_domains.title' | translate}}
  </div>
  <ng-container>
    <div class="box-container" *ngIf="trustedDomains.emails.size == 0 && trustedDomains.domains.size == 0">
      <div class="box-header d-flex">
        <span>{{ 'trusted_domains.header' | translate }}</span>
      </div>
      <div class="box-item">
        <span>{{ 'trusted_domains.empty' | translate }}</span>
      </div>
    </div>

    <ng-container *ngIf="trustedDomains">
      <div *ngFor="let domain of trustedDomains.emails | keyvalue; let i = index" class="box-container">
        <div class="box-header">
          <span class="text-blue-color">{{ 'trusted_domains.trusted_item' | translate }} #{{ i + 1 }}</span>
        </div>

        <div class="box-item">
          <span class="text-blue-color">{{ 'trusted_domains.type' | translate }}:</span>
          <span class="ms-2">
            {{ 'sender.email' | translate }}
          </span>
        </div>
        <div class="box-item d-flex">
          <span class="text-blue-color title">{{ 'trusted_domains.name' | translate }}:</span>
          <span class="ms-2 domain" [matTooltip]="domain.key">
            {{ domain.key }}
          </span>
        </div>

        <div class="box-item justify-content-center">
          <span class="ms-1" >
            <button class="phish-primary-btn" (click)="untrust(domain.key, domain.value, false)"
                    [disabled]="untrustingDomain == domain.value">
              {{ 'shared.untrust_btn' | translate }}
            </button>
          </span>

          <mat-progress-spinner class="ms-1" diameter="20" color="primary" mode="indeterminate"
                                *ngIf="untrustingDomain == domain.value">
          </mat-progress-spinner>
        </div>
      </div>

      <div *ngFor="let domain of trustedDomains.domains | keyvalue; let i = index" class="box-container">
        <div class="box-header">
          <span class="text-blue-color">{{ 'trusted_domains.trusted_item' | translate }} #{{ i + 1 }}</span>
        </div>

        <div class="box-item">
          <span class="text-blue-color">{{ 'trusted_domains.type' | translate }}:</span>
          <span class="ms-2 " >
            {{ 'sender.domain' | translate }}
          </span>
        </div>
        <div class="box-item d-flex">
          <span class="text-blue-color title">{{ 'trusted_domains.name' | translate }}:</span>
          <span class="ms-2 domain" [matTooltip]="domain.key">
            {{ domain.key }}
          </span>
        </div>

        <div class="box-item" style="display: flex; justify-content: center; align-items: center; margin-top: 10px;">
          <span class="ms-1">
            <button class="phish-primary-btn" (click)="untrust(domain.key, domain.value, true)"
                    [disabled]="untrustingDomain == domain.value">
                  {{ 'shared.untrust_btn' | translate }}
            </button>
          </span>
          <mat-progress-spinner class="ms-1" diameter="20" color="primary" mode="indeterminate"
                                *ngIf="untrustingDomain == domain.value">
          </mat-progress-spinner>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
